document.addEventListener('DOMContentLoaded', function() {
    const updatePreferencesForm = document.getElementById('update-preferences-form');
    const unsubscribeCheckbox = document.getElementById('fullyUnsubscribe');
    const updateSubmitBtn = document.querySelectorAll('#update-preferences-form button[type="submit"]');
    const emailInput = document.querySelector('input.form-main-email');
    const idInput = document.querySelector('input[name="customerID"]');
    let endpointHandle = 'preferences';
    let searchHandle = 'search';
    let customerProfile = new URLSearchParams(window.location.search);
    
    let rawEmail = customerProfile.get('email');
    let customerID = customerProfile.get('customerID');
    
    
    function showError(message) {
        const existingMessage = document.querySelector('.error-message');
        if (existingMessage) {
            existingMessage.textContent = message;
        } else {
            const errorMessage = document.createElement('div');
            errorMessage.className = 'error-message';
            errorMessage.textContent = message;
            errorMessage.style.color = 'red';
            errorMessage.style.marginBottom = '10px';
            const submitButton = document.querySelector('.ometria-preferences-form button[type="submit"]');
            submitButton.parentNode.insertBefore(errorMessage, submitButton);
        }
    }
    
    function clearError() {
        const existingMessage = document.querySelector('.error-message');
        if (existingMessage) {
            existingMessage.remove();
        }
    }

    // Replace spaces with '+' to recover the original email
    let email = rawEmail ? rawEmail.replace(/ /g, '+') : '';
    
    // Assign the corrected email to the input field
    emailInput.value = email;
    
    // If customerID is not present, fetch it using the email
    if (!customerID) {
        //console.log('customerID is undefined');
        fetch('https://krw-klav.herokuapp.com/search', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email // Use the corrected email here
            })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch customer ID');
            }
            return response.json();
        })
        .then(data => {
            customerID = data.id;
            idInput.value = customerID;
            //console.log('Fetched Customer ID:', customerID);
        })
        .catch(error => {
            console.error('Error:', error);
            showError('Failed to fetch customer ID. Please try again later.');
        });
    } else {
        idInput.value = customerID;
    }
    
    // Event listener for unsubscribe checkbox
    unsubscribeCheckbox.addEventListener('change', function(event) {
        updateSubmitBtn.forEach(function(btn) {
            btn.textContent = event.target.checked ? 'Unsubscribe' : 'Update Preferences';
        });
    });
    
    // Event listeners for preferences checkboxes
    const preferencesCheckboxes = document.getElementsByName('preferencesCheckboxes');
    
    preferencesCheckboxes.forEach(function(prefCheckbox) {
        prefCheckbox.addEventListener('change', function(event) {
            if (!unsubscribeCheckbox.checked) {
                updateSubmitBtn.forEach(function(btn) {
                    btn.textContent = 'Update Preferences';
                });
            }
        });
    });
    
    // Form submission handler
    updatePreferencesForm.addEventListener('submit', function(event) {
        event.preventDefault();
        //clearError();
    
        const formData = new FormData(updatePreferencesForm);
        const jsonData = {
            email: email, // Use the corrected email here
            customerID: customerID
        };
    
        // Process additional form data
        for (let [key, value] of formData.entries()) {
            if (key !== 'email' && key !== 'customerID') {
                if (!jsonData[key]) {
                    jsonData[key] = [];
                }
                jsonData[key].push(value);
            }
        }
    
        // Determine the endpoint based on unsubscribe checkbox
        if (unsubscribeCheckbox.checked) {
            endpointHandle = 'unsubscribe';
        } else {
            if (!jsonData['preferencesCheckboxes'] || jsonData['preferencesCheckboxes'].length === 0) {
                showError("Please select how often you want to chat");
                return;
            }
    
            if (!jsonData['preferencesCheckboxesGender'] || jsonData['preferencesCheckboxesGender'].length === 0) {
                jsonData['preferencesCheckboxesGender'] = ['V6XHH5'];
            }
    
            if (!jsonData['preferencesCheckboxesStyle'] || jsonData['preferencesCheckboxesStyle'].length === 0) {
                jsonData['preferencesCheckboxesStyle'] = ['XXmcNC'];
            }
    
            updateSubmitBtn.forEach(function(btn) {
                btn.textContent = 'Updating';
                btn.disabled = true;
            });
        }
        
        //console.log('Request started with payload:', jsonData);
        
        // Send the payload to the backend
        fetch(`https://krw-klav.herokuapp.com/${endpointHandle}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jsonData)
        })
        .then(function(response) {
            console.log('Server response status:', response.status);
            if (!response.ok) {
                return response.json().then(errorData => {
                    console.error('Error response:', errorData);
                    throw new Error(errorData.detail || 'An unknown error occurred');
                });
            }
            if (response.status === 204) {
                // Handle 204 No Content response
                return { success: true };
            }
            return response.json();
        })
        .then(function(data) {
            //console.log('Request complete:', data);
            document.getElementById('preferences-wrapper').style.display = 'none';
            document.getElementById('success-message').style.display = 'block';
        })
        .catch(function(error) {
            console.error('Error:', error);
            showError(error.message);
            updateSubmitBtn.forEach(function(btn) {
                btn.textContent = 'Update Preferences';
                btn.disabled = false;
            });
        });
    });
    
    // Radio button toggle handler
    document.querySelectorAll('input[type=radio]').forEach(function(radio) {
        radio.addEventListener('click', function(e) {
            if (e.target.dataset.checked === '1') {
                e.target.checked = false;
                e.target.dataset.checked = '0';
            } else {
                document.querySelectorAll(`input[name=${e.target.name}]`).forEach(function(otherRadio) {
                    otherRadio.dataset.checked = '0';
                });
                e.target.dataset.checked = '1';
            }
        });
    });
});